import React, { Component } from "react";
import { Button, message } from 'antd';
import { ajax, unparam, createTimeStr, hex2Rgba } from "../../../utils/common";
import VideoPlayer from "components/videoPlayer";
import Report from "./report";
import Tabs from "components/tabs";
import Bulk from "./reportItems/bulk";
//css
import "./index.less";
// 国际化
import i18nZh_cn from "utils/zh_cn";
import i18nEn_us from "utils/en_us";

const { TabPanel } = Tabs;

class App extends Component {
	tabRef = React.createRef();

	state = {
		userInfo: {},
		paperInfo: {},
		videoUrl: "",
		selectedIndex: 0,
		isShowBtn:true,
		accountId: "",
		finishStatus: -1,
		autoPlay: true,
		themeColor: "#e81118",	//页面主色
		summary: {},
		result: {},
		currentResult: {},
		inkbarLeft: 0,
		showGenerate: true,
		showLoading: false
	}

	componentDidMount() {
		//获取页面参数
		const queryString = unparam(location.search);
        // 国际化
        const lang = queryString.lang ? queryString.lang.toLocaleLowerCase() : "zh_cn";
        const i18n = lang === "en_us" ? i18nEn_us : i18nZh_cn;
        this.setState({
            i18n
        })
		//获取页面主色
		const themeColor = queryString.themeColor ? queryString.themeColor : this.state.themeColor;
  		// 获取账号信息
  		ajax({
	      	url: "/rept/account/getAccountById",
	      	data: {
	        	accountId: queryString.accountId,
                timestamp: queryString.timestamp,
                sign: queryString.sign,
	        	isAccess: 1
	      	}
	    }).then(account => {
			document.title = account.data.userName + "-" + i18n.index.subtitle2;
	    	this.setState({
	    		finishStatus: account.data.status,
				accountId: queryString.accountId,
	    		userInfo: account.data,
	    		themeColor: themeColor.indexOf("#") >= 0 ? themeColor : ("#" + themeColor)
	    	})
	      	// if (account.data.status === 1) {
			  	this.getPaper(queryString.accountId, true, queryString.timestamp, queryString.sign);
			// }
			if(account.data.aiVaild === 1 || account.data.reportStatus !== 0){
				// 重置tab-ink-bar位置
				setTimeout(() => {
					const tabsItemEl = document.querySelectorAll(".video-tabs>.tabs-item-wrap .tabs-item")[0] || {};
					const offsetLeft = tabsItemEl.offsetLeft;
					const clientWidth = tabsItemEl.clientWidth;
					this.setState({
						inkbarLeft: offsetLeft + (clientWidth - 30)/2
					})
				}, 600)
				//获取视频AI分析汇每秒数据
				ajax({
					url: "/api/file/videoReport/result",
					data: {
						accountId: queryString.accountId
					}
				}).then(res => {
					this.setState({
						result: res.data.processing_result_detailed
					})
				}).catch(err => {
					console.log("result fail: ", err)
				})
				//获取视频AI分析汇总数据
				ajax({
					url: "/api/file/videoReport/summary",
					data: {
						accountId: queryString.accountId
					}
				}).then(res => {
					this.setState({
						summary: res.data,
                        currentResult: res.data && res.data.video_summary ? res.data.video_summary : {}
					})
				}).catch(err => {
					console.log("summary fail: ", err)
				})
			}
			if(account.data.reportStatus != 2 || account.data.reportStatus != 3){
				// 2: 报告已生成，3: 报告生成失败
				/* 定时1分钟去获取报告状态 */
				const timer = setInterval(() => {
					ajax({
						url: "/rept/account/getAccountById",
						data: {
							accountId: queryString.accountId,
							timestamp: queryString.timestamp,
							sign: queryString.sign,
							isAccess: 1
						}
					}).then(res => {
						const userInfo = res.data;
						if(userInfo.reportStatus == 2 || userInfo.reportStatus == 3){
							this.setState({ userInfo })
							clearInterval(timer);
						}
					}).catch(err => {
						console.log("fail: ", err)
					})
				}, 60000)
			}
	    }).catch(err => {
	    	if(err.data.status === 5){
				this.setState({
					finishStatus: 1,
					accountId: queryString.accountId,
					userInfo: err.data,
					themeColor: themeColor.indexOf("#") >= 0 ? themeColor : ("#" + themeColor)
				})
			}else{
				this.setState({
					finishStatus: 0,
					accountId: queryString.accountId,
					userInfo: err.data,
					themeColor: themeColor.indexOf("#") >= 0 ? themeColor : ("#" + themeColor)
				})
			}
			this.getPaper(queryString.accountId, false, queryString.timestamp, queryString.sign);
		})
	}

	//获取试卷
	getPaper = (accountId, showVideo = false, timestamp, sign) => {
		ajax({
			url: "/rept/paper/getPaperById",
			data: {
				accountId,
                timestamp,
                sign,
			}
		}).then(res => {
			//试卷列表
			const interviewQuesVOs = res.data.interviewQuesVOs;
			this.setState({
				paperInfo: res.data
			}, () => {
				//获取第一个视频的url
				showVideo && this.handleClick(interviewQuesVOs[0].questionId, 0);
			})
		})
	}

	handleClick = (qId, index, autoPlay) => {
		//设置选中题号
		this.setState({
			selectedIndex: index,
			autoPlay: autoPlay || false
		})
		//账号删除的情况下无法查看视频
		if(this.state.userInfo.status === 5){
			return false;
		}
		const { accountId, paperInfo } = this.state;
		//获取视频的url
		ajax({
			url: "/api/file/viewVideo",
			data: {
				accountId: accountId,
				paperId: paperInfo.paperId,
				questionId: qId
			}
		}).then(res => {
			this.setState({
				videoUrl: "/oivi/api/file/review/"+ res.data.videoFileUrl
			})
			const tabObj = this.tabRef.current;
			tabObj && tabObj.switchTabs(0);
		})
	}
	//设置自动播放
	playEnd = () => {
		const { selectedIndex, paperInfo } = this.state;
		if(selectedIndex < paperInfo.interviewQuesVOs.length - 1){
			const index = selectedIndex + 1;
			const currentQuestion = paperInfo.interviewQuesVOs[index];
			this.handleClick(currentQuestion.questionId, index, true);
		}
	}

	canPlay = () => {
		if(this.state.autoPlay){
			// this.videoPlayer.current.play();
		}
	}
	//下一个视频
	forward = () => {
		const { selectedIndex, paperInfo } = this.state;
		if(selectedIndex < paperInfo.interviewQuesVOs.length - 1){
			const index = selectedIndex + 1;
			const currentQuestion = paperInfo.interviewQuesVOs[index];
            this.handleClick(currentQuestion.questionId, index);
		}
	}
	//上一个视频
	backward = () => {
		const { selectedIndex, paperInfo } = this.state;
		if(selectedIndex > 0){
			const index = selectedIndex - 1;
			const currentQuestion = paperInfo.interviewQuesVOs[index];
			this.handleClick(currentQuestion.questionId, index);
		}
	}

	// 下载报告
	downloadReport = () => {
		window.open(`/oivi/account/downloadVideoReport?accountId=${this.state.accountId}`);
	}

	// 生成报告
	generateReport = () => {
		const { i18n, showLoading } = this.state;
		if(showLoading) return false;
		this.setState({
			showLoading: true
		})
		ajax({
			url: "/account/analyzeExpression"
		}).then(res => {
			message.success(i18n.report.uploadSuccess);
			this.setState({
				showGenerate: false,
				showLoading: false
			})
		}).catch(err => {
			message.error(err.message || i18n.report.uploadFail);
		})
	}

	handleTabChange = (index) => {
		// 重置tab-ink-bar位置
		const tabsItemEl = document.querySelectorAll(".video-tabs>.tabs-item-wrap .tabs-item")[index];
		const offsetLeft = tabsItemEl.offsetLeft;
		const clientWidth = tabsItemEl.clientWidth;
		this.setState({
			inkbarLeft: offsetLeft + (clientWidth - 30)/2
		})
		if(index == 1 || index == 2){
            ajax({
                url: "/api/file/videoReport/result",
                data: {
                    accountId: this.state.accountId
                }
            }).then(res => {
                this.setState({
                    isShowBtn:false,
                    videoUrl: "/oivi/api/file/videoReport/video?accountId=" + this.state.accountId,
                    result:res.data.processing_result_detailed
                })
            }).catch(err => {
                console.log("result fail: ", err)
            })
		}else if(index == 0){
			const { selectedIndex, paperInfo } = this.state;
			const currentQuestion = paperInfo.interviewQuesVOs[selectedIndex];
			this.handleClick(currentQuestion.questionId, selectedIndex);
            this.setState({
                isShowBtn:true
            })
		}
	}

	handleTimeUpdate = (currentTime) => {
        const { result } = this.state;
        if(!(result && result["1"])) return false;
        if(!currentTime) return false;
        // const index = (parseInt(currentTime/0.03333) || 1) + "";	// 之前的数据大约每秒30个解析数据
        const index = (parseInt(currentTime/0.1) || 1) + "";	// 现在大约是每秒10个解析数据
        let currentResult = result[index]["0"] || {};
        currentResult.emos = currentResult.emos || {};
        currentResult.char = currentResult.char || {};
        for(let k in currentResult){
            let item = currentResult[k];
            for(let key in item){
                currentResult[k][key] = parseFloat((item[key] * 100).toFixed(2));
            }
		}
		console.log("currentResult: ", currentResult)
        this.setState({
            currentResult
        })
	}

    render() {
		const { i18n, userInfo, paperInfo, themeColor, finishStatus, selectedIndex,
			autoPlay, summary, currentResult, inkbarLeft, isShowBtn, showGenerate, showLoading } = this.state;
    	//试题信息
		const interviewQuesVOs = paperInfo.interviewQuesVOs;

		if(!i18n) return null;

		//报告未生成提示
        const reportTips = (
            userInfo.reportStatus == 3 ?
            <p className="report-fail">{i18n.report.reportFail}</p> :
            (
                (userInfo.reportStatus == 0 || userInfo.reportStatus == 2) ? "" :
                <p style={{color: hex2Rgba(themeColor, 0.5)}}>{i18n.report.reportGenerate}</p>
            )
        )

        return (
		    <div className="video-app-wrap">
	            <div className="video-header-wrap"></div>
	            <div className="video-main-wrap">
	            	{/*<div className="paper-tab clearFloat">
	            		<div className="paper-tab-item">{userInfo.userName}</div>
            		</div>*/}
	            	{finishStatus >= 0 ? <div className="paper-wrap">
	            		<div className="paper-title" style={{borderColor: themeColor}}>{i18n.result.title}</div>
						{
							userInfo.aiVaild === 1 && showGenerate && userInfo.reportStatus === 0 &&
							<Button loading={showLoading} className="paper-btn" style={{color: themeColor, borderColor: themeColor}} onClick={this.generateReport}>
								{showLoading ? i18n.report.generate : i18n.report.generateReport}
							</Button>
						}
						<div className="paper-item">
							<p className="paper-item-title">
								<i className="iconfont icon-info paper-item-title-icon"></i>
								<span className="paper-item-title-text">{i18n.result.interviewTitle}</span>
							</p>
							<div className="paper-info">
								<p className="paper-info-item">
									<span className="paper-info-item-label">{i18n.result.recordStatus}:</span>
									<span className="paper-info-item-content"
										title={userInfo.statusDesc}>
										{/* {i18n.result.recordComplete} */}
										{userInfo.statusDesc}
									</span>
								</p>
								<p className="paper-info-item">
									<span className="paper-info-item-label">{i18n.result.submitStatus}:</span>
									<span className="paper-info-item-content"
										title={userInfo.submitStatusDesc}>
										{userInfo.submitStatusDesc}
									</span>
								</p>
								<p className="paper-info-item">
									<span className="paper-info-item-label">{i18n.result.finishTime}:</span>
									<span className="paper-info-item-content"
										title={userInfo.finishTime}>
										{userInfo.finishTime}
									</span>
								</p>
							</div>
							<div className="paper-info">
								<p className="paper-info-item">
									<span className="paper-info-item-label">{i18n.result.totalFileDuration}:</span>
									<span className="paper-info-item-content"
										title={createTimeStr(userInfo.totalFileDuration)}>
										{createTimeStr(userInfo.totalFileDuration)}
									</span>
								</p>
								<p className="paper-info-item">
									<span className="paper-info-item-label">{i18n.result.startTime}:</span>
									<span className="paper-info-item-content"
										title={userInfo.startTimeStr}>
										{userInfo.startTimeStr}
									</span>
								</p>
								<p className="paper-info-item">
									<span className="paper-info-item-label">{i18n.result.endTime}:</span>
									<span className="paper-info-item-content"
										title={userInfo.endTimeStr}>
										{userInfo.endTimeStr}
									</span>
								</p>
							</div>
							<div className="paper-info">
								<p className="paper-info-item">
									<span className="paper-info-item-label">{i18n.result.paperName}:</span>
									<span className="paper-info-item-content"
										title={i18n.lang == "en_us"? paperInfo.paperNameEn : paperInfo.paperName}>
										{i18n.lang == "en_us"? paperInfo.paperNameEn : paperInfo.paperName}
									</span>
								</p>
								<p className="paper-info-item">
									<span className="paper-info-item-label">{i18n.result.questionNum}:</span>
									<span className="paper-info-item-content"
										title={paperInfo.questionNum}>
										{paperInfo.questionNum}
									</span>
								</p>
								<p className="paper-info-item">
									<span className="paper-info-item-label">{i18n.result.videoResource}:</span>
									<span className="paper-info-item-content"
										title={userInfo.videoResource}>
										{userInfo.videoResource}
									</span>
								</p>
							</div>
							<div className="paper-info">
								<p className="paper-info-item">
									<span className="paper-info-item-label">{i18n.result.fileStatus}:</span>
									<span className="paper-info-item-content"
										title={userInfo.fileStatus=="1"?i18n.result.fileNotExist:i18n.result.fileExist}>
										{userInfo.fileStatus=="1"?i18n.result.fileNotExist:i18n.result.fileExist}
									</span>
								</p>
							</div>
						</div>
						<div className="paper-item">
							<p className="paper-item-title">
								<i className="iconfont icon-question paper-item-title-icon"></i>
								<span className="paper-item-title-text">{i18n.result.videoTitle}</span>
							</p>
							{
								(userInfo.aiVaild === 1 || userInfo.reportStatus !== 0) ?
								<Tabs themeColor={themeColor}
									wrapClass="video-tabs"
									ref={this.tabRef}
									tabBarExtraContent={reportTips}
									onTabChange={this.handleTabChange}
									tabExtraContent={
										<div className="paper-detail clearFloat">
											<div className="tabs-ink-bar" style={{
												left: inkbarLeft + "px",
                                                background: themeColor
											}}></div>
											<div className="paper-question-list">
												{interviewQuesVOs&&interviewQuesVOs.map((item, index) => {
													return (
														<div className={"paper-question-item " + (selectedIndex === index && isShowBtn ?"selected":"")}
															onClick={() => {
																if(isShowBtn){
                                                                    this.handleClick(item.questionId, index)
																}
                                                            }}
															key={index}>
															<p className="paper-question-item-label">Q{index + 1}:</p>
															<p className="paper-question-item-content">{i18n.lang == "en_us" ? item.enName : item.cnName}</p>
															<i className="iconfont icon-corner paper-question-item-tag" style={{color: themeColor}}></i>
														</div>
													)
												})}
											</div>
											<div className="paper-video-list">
												<VideoPlayer
													handleCanPlay={this.canPlay}
													handleEnded={this.playEnd}
													forward={this.forward}
													backward={this.backward}
													autoPlay={autoPlay}
													handleTimeUpdate={this.handleTimeUpdate}
													videoUrl={this.state.videoUrl}
													themeColor={themeColor} />
											</div>
										</div>
									}>
									<TabPanel tab={i18n.report.originalVideo}></TabPanel>
									<TabPanel tab={i18n.report.liveAnalysis} hidden={userInfo.reportStatus != 2}>
										{userInfo.emoProducer === 'human' && <Bulk data={currentResult} i18n={i18n} />}
									</TabPanel>
									<TabPanel tab={i18n.report.analysisReport} hidden={userInfo.reportStatus != 2}>
										<Report isHuman={userInfo.emoProducer === 'human'} summary={summary} themeColor={themeColor} i18n={i18n} />
									</TabPanel>
								</Tabs>:
								<div className="paper-detail clearFloat">
									<div className="paper-question-list">
										{interviewQuesVOs&&interviewQuesVOs.map((item, index) => {
											return (
												<div className={"paper-question-item " + (selectedIndex === index && isShowBtn ?"selected":"")}
													onClick={() => {
														if(isShowBtn){ this.handleClick(item.questionId, index) };
                                                    }}
													key={index}>
													<p className="paper-question-item-label">Q{index + 1}:</p>
													<p className="paper-question-item-content">{i18n.lang == "en_us" ? item.enName : item.cnName}</p>
													<i className="iconfont icon-corner paper-question-item-tag" style={{color: themeColor}}></i>
												</div>
											)
										})}
									</div>
									<div className="paper-video-list">
										<VideoPlayer
											handleCanPlay={this.canPlay}
											handleEnded={this.playEnd}
											forward={this.forward}
											backward={this.backward}
											autoPlay={autoPlay}
											handleTimeUpdate={this.handleTimeUpdate}
											videoUrl={this.state.videoUrl}
											themeColor={themeColor} />
									</div>
								</div>
							}
						</div>
						{/* {
							userInfo.aiVaild === 1 ? (userInfo.reportStatus == 2 ? //<Report themeColor={themeColor} />:null
							<div className="paper-download-wrap">
								<button style={{color: themeColor, borderColor: themeColor}} onClick={this.downloadReport}>{i18n.report.download}</button>
							</div>:
							<div className="paper-download-wrap">
								<button disabled>{i18n.report.generate}</button>
							</div>) : null
						} */}
					</div> : (finishStatus < 0 ? null : <div className="paper-wrap">
						<h3 className="paper-nodata">{i18n.result.recordNotFinish}</h3>
					</div>)}
	            </div>
        	</div>
        );
    }
}

export default App;
